exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2h4-tg5EP5ehOGyJ9kWNft,._3NqB_SZXg2cYDoJgioWw0t{font-size:12px;font-weight:400}._3NqB_SZXg2cYDoJgioWw0t{color:\"[theme:neutralPrimary, default:#333333]\";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:450px}._24SG8xjqdnzGmle4JB-SEc{height:19px;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}html[dir] ._24SG8xjqdnzGmle4JB-SEc{border:none;padding:0}._1B00pQpVD5QFymHpRmeBzP{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}html[dir=ltr] ._1B00pQpVD5QFymHpRmeBzP{padding-right:3px}html[dir=rtl] ._1B00pQpVD5QFymHpRmeBzP{padding-left:3px}._3Pw3OjQCN96m2dz7sjUmBH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"commandButtonTextLabel": "_2h4-tg5EP5ehOGyJ9kWNft",
	"menuItemText": "_3NqB_SZXg2cYDoJgioWw0t",
	"multipleOptionCommandButton": "_24SG8xjqdnzGmle4JB-SEc",
	"preActionText": "_1B00pQpVD5QFymHpRmeBzP",
	"mainContainer": "_3Pw3OjQCN96m2dz7sjUmBH"
};